import { useEffect } from "react";
import { useDataLoader } from "2g-hooks/fetch";
import { DATA } from "b2b/api/paths";

export default function useProvozniInformace(id) {
  const loader = useDataLoader({
    url: DATA.provozniInformace(id),
    method: "get",
    lazy: true
  });

  useEffect(() => {
    id !== undefined && loader.load();
  }, [id]);

  return loader;
}
